import { render } from "./VerticalProductCard.vue?vue&type=template&id=57ea5efa"
import script from "./VerticalProductCard.vue?vue&type=script&lang=js"
export * from "./VerticalProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__